// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"489df2f7","453":"4a1f2408"}[chunkId] + ".chunk.js";
};